import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ShoppingCartOutlined,
  FileSearchOutlined,
  SafetyOutlined,
  DollarOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  request: <ShoppingCartOutlined />,
  quote: <FileSearchOutlined />,
  approve: <SafetyOutlined />,
  payment: <DollarOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("pms");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-pms-workflow-grid",
        isCompact ? "dev-pms-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-pms-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-pms-step-item">
                <div className={`dev-pms-step-card dev-pms-step-card--${step.key}`}>
                  <div className="dev-pms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-pms-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-pms-step-card dev-pms-step-card--${step.key}`}>
                <div className="dev-pms-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-pms-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-pms-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
